
import Routes from 'rde-view-common/constants/Routes';
import { logoutSilent } from 'rde-view-common/middleware/auth';
import { getCurrentJst } from 'rde-view-common/scripts/dateUtils';
import { copy, getNestedVal, isBlank, isNotEmpty } from 'rde-view-common/scripts/functions';
import StoreUtils from 'rde-view-common/scripts/storeUtils';

/**
 * 共通エラー画面
 */
export default {
  props: {
    error: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data: () => {
    return {
      isSystemError: false,
      errorDate: '',
      errorStatus: '',
      errorObj: {},
      labelHere: ''
    };
  },
  created() {
    if (this.error.isAxiosError) {
      this.labelHere = this.$label(this.$labelIds.SCR_COM_1010_HERE);
      this.errorObj.message = this.$msg(this.$msgIds.MSG_COM_E_0010, [this.labelHere]).split(this.labelHere);
      this.isSystemError = true;
      this.errorDate = getCurrentJst();
      return;
    }

    const storedError = this.$store.state.systemErrorObj;
    const isStored = isNotEmpty(storedError);
    console.log('error:', { stored: isStored, errorObj: isStored ? storedError : this.error });

    if (!isStored && isNotEmpty(this.error)) {
      // storeにエラー情報がない場合、かつ、propsにerrorが渡された場合は
      // vueの実行時例外であるため、一旦ストアに保存して再度エラーページに遷移させる。
      if (this.error.statusCode === 404) {
        this.$store.commit(
          'systemErrorObj',
          { status: 404, message: this.$msg(this.$msgIds.MSG_COM_W_0430), keepsSession: true }
        );
      } else {
        this.$store.commit('systemErrorObj', this.error);
      }
      this.$router.push(Routes.COMMON_ERROR.path);
      return;
    }

    this.errorObj = isStored ? copy(storedError) : {};
    this.errorDate = getCurrentJst();
    this.errorObj.status = getNestedVal(this.errorObj, 'status') || 500;

    const env = process.env.NODE_ENV;
    // エラーメッセージが設定されていない場合、またはエラーコードが500の場合はシステムエラーのメッセージとする。
    if (isBlank(this.errorObj.message) || (this.errorObj.status === 500 && env !== 'development')) {
      this.labelHere = this.$label(this.$labelIds.SCR_COM_1010_HERE);
      this.errorObj.message = this.$msg(this.$msgIds.MSG_COM_E_0010, [this.labelHere]).split(this.labelHere);
      this.isSystemError = true;
    }

    if (this.errorObj.keepsSession !== true) {
      logoutSilent();
      StoreUtils.clearAll();
    }
  },
  destroyed() {
    // 後続処理に影響を及ぼさないように削除
    this.$store.commit('systemErrorObj', null);
  },
  methods: {
    // トップへ戻る
    moveToTop() {
      location.href = this.$config.links.systemTop;
    }
  }
};
